import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js'

// Product options
document.querySelectorAll('.product-option').forEach(($option) => {
    $option.addEventListener('change', () => {
        const $form = $option.closest('form[action="/cart/add"]')

        const selectedOptions = []

        $form.querySelectorAll('.product-option').forEach(($option2) => {
            if ($option2.type === 'radio') {
                if ($option2.checked) {
                    selectedOptions.push($option2.value)
                }
            } else {
                selectedOptions.push($option2.value)
            }
        })

        const selectedVariant = JSON.parse($form.dataset.variants).find(
            (variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )

        // console.log(selectedVariant);

        const $addToCartBtn = $form.querySelector('.btn-atc')

        if (selectedVariant) {
            // console.log(selectedVariant);

            $form.querySelector('select[name="id"]').value = selectedVariant.id

            if (selectedVariant.available) {
                $addToCartBtn.disabled = false
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textAddToCart
            } else {
                $addToCartBtn.disabled = true
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textSoldOut
            }

            const productPriceContainer = $form.closest('#product-page').querySelector('.product-price-container')

            productPriceContainer.querySelector('.product-price-final')
                .textContent = window.formatMoney(selectedVariant.price)

            if (selectedVariant.compare_at_price) {
                productPriceContainer.querySelector('.product-price-compare')
                    .textContent = window.formatMoney(selectedVariant.compare_at_price)
                productPriceContainer.querySelector('.product-price-compare')
                    .classList.remove('d-none')
            } else {
                productPriceContainer.querySelector('.product-price-compare')
                    .classList.add('d-none')
            }

            window.history.replaceState({}, '', `${$form.dataset.productUrl}?variant=${selectedVariant.id}`)

            if (selectedVariant.featured_media) {
                bootstrap.Carousel.getInstance($form.closest('.product').querySelector('.product-carousel'))
                    .to(selectedVariant.featured_media.position - 1)
            }
        } else {
            $addToCartBtn.disabled = true
            $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textUnavailable
            window.history.replaceState({}, '', window.product.url)
        }
    })
})

// Product Media Gallery - Full Screen Gallery with PhotoSwipe
// https://photoswipe.com/v5/docs/getting-started/
const initProductMediaGallerySwipe = () => {
    document.querySelectorAll('#product-page .product-carousel').forEach(($carousel) => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: $carousel,
            children: 'a',
            pswpModule: './photoswipe.esm.min.js'
        })
        lightbox.init()
    })
}
initProductMediaGallerySwipe()

// Product Media Gallery - Sticky position on scroll (only in desktop)
const initProductMediaGallerySitcky = () => {
    document.querySelectorAll('.sticky-carousel').forEach(($carousel) => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
                $carousel.style.position = 'sticky'
                $carousel.style.top = `${navbarHeight + 20}px`
            }
        })
    })
}
initProductMediaGallerySitcky()

// Handle Ingredients
const handleIngredients = async () => {
    const ingredientsBlock = document.querySelector('.product-block-ingredients')

    if (ingredientsBlock) {
        const response = await fetch(ingredientsBlock.dataset.jsonFile)
        const data = await response.json()
        console.log(data)

        document.querySelectorAll('.ingredients-list-item').forEach((item) => {
            const ingredientData = data[item.dataset.ingredient]

            if (ingredientData) {
                item.querySelector('.ingrdients-list-score').innerHTML = ingredientData.score
                item.querySelector('.ingrdients-list-score').style.backgroundColor = ingredientData.score > 2 ? 'orange' : 'green'

                item.querySelector('[data-ingredient-origin]').innerHTML = ingredientData.origin
                item.querySelector('[data-ingredient-description]').innerHTML = ingredientData.description
            }
        })

        document.querySelectorAll('.btn-ingredients-show-all').forEach((btn) => {
            btn.addEventListener('click', () => {
                btn.closest('.accordion-body').querySelectorAll('.ingredients-list-item').forEach(item => {
                    item.style.display = 'flex'
                })
                btn.remove()
            })
        })
    }
}
handleIngredients()

// YotPo reviews on product page - small fixes
const $yotooMainWidget = document.querySelector('.yotpo.yotpo-main-widget')
if ($yotooMainWidget) {
    $yotooMainWidget.classList.add('container')
}

// Marquee on product page - move it on mobile below the image gallery
const fixMarqueePositionMobile = () => {
    let $marquee = document.querySelector('body.request-page-type-product .shopify-section > .marquee')

    if ($marquee) {
        $marquee = document.querySelector('.marquee-section-wrapper .marquee')

        const handleTask = () => {
            if (window.matchMedia('(max-width: 991px)').matches) {
                document.querySelector('#product-page .product-carousel').append($marquee)
            } else {
                document.querySelector('.marquee-section-wrapper').append($marquee)
            }
        }
        handleTask()

        window.addEventListener('resize', () => {
            handleTask()
        })
    }
}
fixMarqueePositionMobile()

// Recharge widget
document.querySelectorAll('[name="recharge-widget-type"]').forEach(input => {
    input.addEventListener('change', () => {
        const finalPriceEl = input.closest('#product-page-content').querySelector('[data-product-price]')

        if (input.value === 'one-time') {
            document.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'none'
            // eslint-disable-next-line no-template-curly-in-string
            finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.productPrice, '${{ amount_no_decimals }}')
        } else {
            document.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'block'
            finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.subPrice)
        }
    })
})
